import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { ChangeEvent } from "react";

import { Input } from "@/components/Form/Base/input.component";
import { Label } from "@/components/Form/Base/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ActionsComponentProps = {
    differenceOnly: boolean;
    className?: string;
    onShowOnlyDifferenceChange: (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
};

const ActionsComponent = ({
    differenceOnly,
    className,
    onShowOnlyDifferenceChange
}: ActionsComponentProps) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:h-16", className)}>
            <div
                className={cn(
                    "tw:absolute tw:flex tw:justify-end tw:flex-col tw:w-full tw:top-[unset]",
                    "tw:md:[@media(min-height:500px)]:h-full"
                )}
            >
                <Button
                    className={cn("tw:p-0 tw:text-left")}
                    color={"link"}
                    onClick={() => window.print()}
                    type={"button"}
                >
                    <i className={cn("la-lg las la-print", "tw:mr-2")} />
                    {t("productComparison.print")}
                </Button>
                <Label className={cn("tw:m-0")}>
                    <Input
                        className={cn("tw:relative tw:my-0 tw:mr-3 tw:ml-1")}
                        type={"checkbox"}
                        checked={differenceOnly}
                        onChange={onShowOnlyDifferenceChange}
                    />
                    {t("productComparison.onlyShowDifferences")}
                </Label>
            </div>
        </div>
    );
};

export { ActionsComponent };
